import { render, staticRenderFns } from "./ManageCall.vue?vue&type=template&id=42399498"
import script from "./ManageCall.vue?vue&type=script&lang=js"
export * from "./ManageCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports